const buttonData = [
    {
        color: 'primary',
        name: 'Primary'
    },
    {
        color: 'secondary',
        name: 'Secondary'
    },
    {
        color: 'success',
        name: 'Success'
    },
    {
        color: 'info',
        name: 'Info'
    },
    {
        color: 'warning',
        name: 'Warning'
    },
    {
        color: 'danger',
        name: 'Danger'
    },
    {
        color: 'dark',
        name: 'Dark'
    },
    {
        color: 'purple',
        name: 'Purple'
    },
    {
        color: 'pink',
        name: 'Pink'
    },
    {
        color: 'light',
        name: 'Light'
    }
];

const iconData = [
    {
        name: 'far fa-heart',
        color: 'secondary'
    },
    {
        name: 'fas fa-times',
        color: 'danger'
    },
    {
        name: 'fa fa-music',
        color: 'purple'
    },
    {
        name: 'fa fa-star',
        color: 'primary'
    },
    {
        name: 'far fa-thumbs-up',
        color: 'success'
    },
    {
        name: 'far fa-keyboard',
        color: 'info'
    },
    {
        name: 'fa fa-wrench',
        color: 'warning'
    }
];

const iconButton = [
    {
        name: ' Like',
        icon: 'fa fa-heart',
        color: 'secondary'
    },
    {
        name: ' Share',
        icon: 'far fa-envelope',
        color: 'dark'
    },
    {
        name: ' Launch',
        icon: 'fa fa-rocket',
        color: 'warning'
    },
    {
        name: ' Cloud Hosting',
        icon: 'fa fa-cloud',
        color: 'info'
    },
    {
        name: ' Book Flight',
        icon: 'fa fa-plane',
        color: 'danger'
    },
    {
        name: ' Donate Money',
        icon: 'far fa-money-bill-alt',
        color: 'purple'
    }
];
export { buttonData, iconData, iconButton };
